import React, { useContext, useEffect } from 'react'

import { connect } from 'react-redux'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import HotelsTabContent from './HotelsTabContent'
import { GlobalSearchDispatchContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

interface MappedStateProps {
  selectedTravellerEmployeeIds?: Array<string>
  selectedTravellerGuestCount?: number
}

interface Props {
  onSearch: () => void
}

function HotelTabContentComponent(props: Props & MappedStateProps) {
  const { onSearch, selectedTravellerEmployeeIds, selectedTravellerGuestCount } = props

  const globalSearchDispatch = useContext(GlobalSearchDispatchContext)

  useEffect(() => {
    if (selectedTravellerEmployeeIds && selectedTravellerGuestCount !== undefined) {
      globalSearchDispatch({ type: GlobalSearchStateActions.SET_OCCUPANCIES, occupancies: [{ adults: (selectedTravellerEmployeeIds.length + selectedTravellerGuestCount) || 1 }] })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- only run on mount
  }, [globalSearchDispatch])

  return (<HotelsTabContent onSearch={onSearch} />)
}

export default connect<MappedStateProps, undefined, undefined, App.State>((appState) => {
  return {
    selectedTravellerEmployeeIds: appState.businessTraveller.selectedTravellerEmployeeIds,
    selectedTravellerGuestCount: appState.businessTraveller.selectedTravellerGuestCount,
  }
})(HotelTabContentComponent)
